<template>
    <div class="flow-edit">
        <flow-graph :flow-id="props.flowId" />
    </div>

    <router-view />
</template>

<script setup lang="ts">
    import FlowGraph from '@/flow/flow/components/graph/FlowGraph.vue';

    const props = defineProps<{ flowId: string }>();
</script>

<style scoped lang="scss">
.flow-edit {
    position: absolute;
    inset: 0;
}
</style>
